"use client";

import { cn, Typography } from "@kyan/ui";

import { LastTradesTable } from "#/components/LastTradesTable/LastTradesTable";
import { useLastPerpTradesByInstrument } from "#/hooks/useLastPerpTradesByInstrument";

interface PerpsLastTradesProps {
  className?: string;
}

export const PerpsLastTrades: React.FC<PerpsLastTradesProps> = ({
  className,
}) => {
  const { lastTrades, isLoading, underlying } = useLastPerpTradesByInstrument();

  return (
    <div
      className={cn(
        "flex w-70 flex-col gap-1.5 overflow-y-auto 2xl:w-97.5",
        className,
      )}
    >
      <Typography grotesk primary size={12} className="pl-1">
        Trades
      </Typography>
      <LastTradesTable
        variant="perps"
        isLoading={isLoading}
        lastTrades={lastTrades}
        underlying={underlying}
      />
    </div>
  );
};
